import { useState } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { apiClient } from 'shared/api';
import { DashboardHeaderBackLink } from 'widgets/dashboard-header-back-link';
import styles from './import-excel.module.scss';

export const ImportExcelPage = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFile(event.target.files[0]);
      setError(null);
      setSuccess(null);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setError('Пожалуйста, выберите файл для импорта');
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      await apiClient.post('/vehicles/import-excel', formData, {

      });
      setSuccess('Файл успешно импортирован!');
    } catch (err: any) {
      setError(err.response?.data?.error?.message || 'Ошибка при импорте файла');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={styles.importPage}>
      <DashboardHeaderBackLink link={'/dashboard/admin/catalog'} title={'Импорт из Excel'} />
      <Box className={styles.content}>
        <Typography variant='h5' component='h2' gutterBottom>
          Загрузите файл Excel для импорта данных
        </Typography>
        <Typography variant='body1' color='textSecondary' paragraph>
          Выберите Excel файл с данными о транспортных средствах. Система автоматически обработает
          данные и добавит их в каталог.
        </Typography>

        <Box className={styles.uploadBox}>
          <Button variant='contained' component='label'>
            Выберите файл
            <input type='file' hidden accept='.xlsx, .xls' onChange={handleFileChange} />
          </Button>
          {selectedFile && (
            <Typography variant='body1' className={styles.fileName}>
              {selectedFile.name}
            </Typography>
          )}
        </Box>

        <Button
          variant='contained'
          color='primary'
          onClick={handleUpload}
          disabled={!selectedFile || loading}
          className={styles.importButton}
        >
          {loading ? <CircularProgress size={24} /> : 'Импортировать'}
        </Button>

        {error && (
          <Typography color='error' className={styles.message}>
            {error}
          </Typography>
        )}
        {success && (
          <Typography color='primary' className={styles.message}>
            {success}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
